import UKDialog from '@/components/UKDialog';
import { useTranslation } from '@/i18n/client';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { observer } from 'mobx-react';
import CommonButton from '../commonButton';
import styles from './index.module.scss';
// 接口
import { TagMainContentMap } from '@/apis/order/order.interface';

interface ageTipsModalProps {
  modalInfo: TagMainContentMap | null;
  isOpen: boolean;
  closeHandler: () => void;
}

const ageTipsModal: React.FC<ageTipsModalProps> = observer(
  ({ modalInfo, isOpen, closeHandler }) => {
    const { t } = useTranslation();

    return (
      <UKDialog
        open={isOpen}
        onClose={closeHandler}
        showCloseBtn={true}
        className={styles.repayOrderModal}
        sx={{
          '& .MuiDialog-paper': {
            width: '520px', // 设置自定义宽度
          },
        }}
      >
        <DialogTitle>{modalInfo?.title}</DialogTitle>
        <DialogContent
          sx={{
            maxHeight: '570px',
            paddingBottom: 0,
          }}
        >
          <div
            className={styles.tipContent}
            dangerouslySetInnerHTML={{
              __html: modalInfo?.content || '',
            }}
          ></div>
        </DialogContent>
        <DialogActions
          sx={{
            paddingTop: '20px',
          }}
        >
          <CommonButton variant='contained' onClick={closeHandler} sx={{ boxShadow: 'none' }}>
            {t('common.btnText.ok')}
          </CommonButton>
        </DialogActions>
      </UKDialog>
    );
  },
);

export default ageTipsModal;
